/**
 * Swaps the large preview image/title in a .mega-menu-hover-preview panel
 * to match whichever .mega-menu-hover-preview--link is hovered.
 */
(function () {
  function initPanel(panel) {
    var links = panel.querySelectorAll('.mega-menu-hover-preview--link');
    var image = panel.querySelector('.mega-menu-hover-preview--image');
    var title = panel.querySelector('.mega-menu-hover-preview--title');
    if (!links.length || !image) return;

    function setActive(link) {
      links.forEach(function (l) {
        l.classList.remove('active');
      });
      link.classList.add('active');
      var src = link.getAttribute('data-preview-image');
      var text = link.getAttribute('data-preview-title') || '';
      if (src) {
        image.src = src;
        image.alt = text;
      }
      if (title) title.textContent = text;
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        setActive(link);
      });
      link.addEventListener('focus', function () {
        setActive(link);
      });
    });

    var initial = panel.querySelector('.mega-menu-hover-preview--link.active') || links[0];
    setActive(initial);
  }

  document.querySelectorAll('.mega-menu-hover-preview').forEach(initPanel);
})();
